module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"WidgetWA2hs":{"add":"Добавить"}},"en_us":{"WidgetWA2hs":{"add":"Add"}}}')
  delete Component.options._Ctor
}
